export default __webpack_public_path__ + "static/media/fasttrackLogo.b59eefef.png";